/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-07-22 17:27:28
 * @LastEditTime: 2019-10-22 04:08:38
 * @LastEditors: Please set LastEditors
 */
console.log(process.env.MODE)
let appId, linkUrl, ssoUrl
switch (process.env.MODE) {
  /* 生产 */
  case 'prod':
    appId = 'wx4e5eba56d447aa0a'
    linkUrl = 'https://api.imways.com'
    ssoUrl = 'https://mc.imways.com/sso'
    break
  /* 测试 */
  case 'test':
    appId = 'wx55bd47bb75134cf9'
    linkUrl = 'http://api.xymtest.com'
    ssoUrl = 'http://member.xymtest.com/sso'
    break
  case 'test1':
    appId = 'wxebea37ca1b889fa9'
    linkUrl = 'http://api1.xymtest.cn'
    ssoUrl = 'http://member1.xymtest.cn/sso'
    break
  case 'test2':
    appId = 'wx1359278315ad1766'
    linkUrl = 'http://api2.xymtest.cn'
    ssoUrl = 'http://member2.xymtest.cn/sso'
    break
  case 'test3':
    appId = 'wx32c137f5a0efbc95'
    linkUrl = 'http://api3.xymtest.cn'
    ssoUrl = 'http://member3.xymtest.cn/sso'
    break
  /* 开发 */
  default:
    // appId = 'wxc939604d611c951e'
    // linkUrl = 'http://api1.xymtest.com'
    // ssoUrl = 'http://member1.xymtest.com/sso'
    // linkUrl = 'http://api.xymdev.com'
    // ssoUrl = 'http://mc.xymdev.com/sso'
    // appId = 'wxf887eaa314b0fd3c'
    appId = 'wx32c137f5a0efbc95'
    linkUrl = 'http://api3.xymtest.cn'
    ssoUrl = 'http://member3.xymtest.cn/sso'
    break
}
var config = {
  appId: appId,
  linkUrl: linkUrl,
  ssoUrl: ssoUrl,
  qqMapSDK: '4NWBZ-U24RJ-LLAF3-F37DQ-QXSMQ-RTFWB'
}
module.exports = config



// WEBPACK FOOTER //
// ./static/config.js